import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.tag), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {
        amount: $options.displayedAmount,
        formattedOriginalAmount: $options.formattedOriginalAmount,
        formattedNativeAmount: $options.formattedNativeAmount,
        isConverted: $options.isConverted,
        displayCurrency: _ctx.selectedDisplayCurrency
      }, () => [
        _createTextVNode(_toDisplayString($options.formattedOriginalAmount), 1 /* TEXT */)
      ])
    ]),
    _: 3 /* FORWARDED */
  }))
}